import { Grid, Typography, Box } from '@mui/material';

const OrderSummaryItem = ({ label, value, testId }) => {
  return (
    <Box>
      <Grid container spacing={2} mt={0}>
        <Grid size={{ xs: 6 }}>
          <Typography ml={2} variant="subtitle2" sx={{ fontWeight: '700' }}>
            {label}
          </Typography>
        </Grid>
        <Grid size={{ xs: 6 }}>
          <Typography
            mr={2}
            variant="subtitle2"
            gutterBottom
            sx={{
              fontWeight: '700',
              display: 'flex',
              justifyContent: 'flex-end',
            }}
            data-testid={testId}
          >
            {value}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};
export default OrderSummaryItem;
